/**
 * qiyu customer service mixin
 */
import Cookies from 'js-cookie'
// import { oneApi, CustomerService } from 'config/api'
import QIYU_CONFIG from './config'
import { initQiyuCustomerService } from './utils'

export default {
  data() {
    return {
      // user data
      language: '',
      uid: '',
      accountCard: '',
      schoolCode: '',
      schoolTag: '',
      referrer: '',
      title: '',

      // parent info
      parentInfo: {},
      latestRobot: '',

      // status management
      isInitializing: false,
      initError: null,
    }
  },

  methods: {
    /**
     * get user params from cookies
     */
    getParamsByCookies() {
      const defaults = QIYU_CONFIG.DEFAULTS
      this.language = Cookies.get('_app_language') || defaults.language
      this.uid = Cookies.get('_app_uid') || defaults.uid
      this.accountCard = Cookies.get('_app_card_id') || defaults.accountCard
      this.schoolCode = Cookies.get('_app_school_code') || defaults.schoolCode
      this.schoolTag = Cookies.get('_app_school_tag') || defaults.schoolTag
      this.referrer = Cookies.get('_app_referrer') || defaults.referrer
      this.title = Cookies.get('_app_title') || defaults.title
    },

    /**
     * get parent info
     */
    // async getParentInfo() {
    //   try {
    //     const res = await this.$axios.post(oneApi.getParentInfo, {}, { rewritePostBody: true })

    //     if (Number(res.code) !== 0) {
    //       this.showError(res.msg)
    //       return null
    //     }

    //     this.parentInfo = res.data || {}
    //     return this.parentInfo
    //   } catch (error) {
    //     console.error('get parent info failed:', error)
    //     this.showError('get parent info failed')
    //     return null
    //   }
    // },

    /**
     * get latest robot config
     */
    // async getLatestRobot() {
    //   try {
    //     const res = await this.$axios.post(CustomerService.getLatestRobot, {
    //       accountId: Number(this.uid),
    //     }, { rewritePostBody: true })

    //     if (Number(res.code) !== 0) {
    //       this.showError(res.msg)
    //       return null
    //     }

    //     this.latestRobot = res.data.robotId || ''
    //     return this.latestRobot
    //   } catch (error) {
    //     console.error('get latest robot failed:', error)
    //     this.showError('get latest robot failed')
    //     return null
    //   }
    // },

    /**
     * initialize qiyu customer service
     */
    async initQiyu() {
      if (this.isInitializing) {
        console.log('qiyu sdk init...')
        return
      }

      this.isInitializing = true
      this.initError = null

      try {
        // get user data
        const userData = {
          language: this.language,
          accountCard: this.accountCard,
          schoolTag: this.schoolTag,
          referrer: this.referrer,
          title: this.title,
          latestRobot: this.latestRobot,
        }

        // initialize qiyu customer service
        await initQiyuCustomerService(userData, this.parentInfo)

        console.log('qiyu sdk init success')
      } catch (error) {
        console.error('qiyu sdk init failed:', error)
        this.initError = error
        this.showError('qiyu sdk init failed, please try again later')
      } finally {
        this.isInitializing = false
      }
    },

    /**
     * show error message
     */
    showError(message) {
      const webClient = process.env.clientType === 'web'
      if (webClient) {
        this.$ElMessage?.error(message)
      } else {
        this.$Toast?.fail({
          message,
          duration: 1500,
        })
      }
    },

  },
}
